import flash, { reducer as flashReducer } from 'actions/flash';
import nav, { reducer as navReducer } from 'actions/nav';
import modal, { reducer as modalReducer } from 'actions/modal';
// eslint-disable-next-line no-restricted-imports -- W10: reducer plus the narrowed fetchAddress/clear only
import lookup, { reducer as lookupReducer } from 'actions/lookup';
// eslint-disable-next-line no-restricted-imports -- W10: reducer only (the shared <Collection> reads state.data)
import { reducer as dataReducer } from 'actions/data';
import client, { reducer as clientReducer } from 'actions/client';
import partner, { reducer as partnerReducer } from './partner';
import session, { reducer as sessionReducer } from './session';
import user, { reducer as userReducer } from './user';
import apps from './apps';
import clients from './clients';
import files from './files';

export const actions = {
  partner,
  session,
  user,
  apps,
  clients,
  files,
  flash,
  nav,
  modal,
  // W10: only the SmartyStreets address lookup is exposed; `query` and
  // `multiModelQuery` read /data and are forbidden in the portal
  lookup: {
    fetchAddress: lookup.fetchAddress,
    clear: lookup.clear,
    results: lookup.results,
    loading: lookup.loading,
  },
  client,
};

export const reducers = {
  partner: partnerReducer,
  session: sessionReducer,
  user: userReducer,
  flash: flashReducer,
  nav: navReducer,
  modal: modalReducer,
  lookup: lookupReducer,
  data: dataReducer,
  client: clientReducer,
};

export default actions;
